import type {CssValue} from '../../constants'
import {CLOSING_BRACKETS, OPENING_BRACKETS} from './function'

export const splitValue = (val: CssValue, delimiter: string): CssValue[] => {
    const arr: CssValue[] = []
    let item = ''
    let bracketsCounter = 0
    for (const char of val) {
        if (char === delimiter && bracketsCounter === 0) {
            arr.push(item)
            item = ''
            continue
        }

        if (char === OPENING_BRACKETS) {
            bracketsCounter++
        } else if (char === CLOSING_BRACKETS && bracketsCounter !== 0) {
            bracketsCounter--
        }

        item += char
    }

    if (item.length > 0) {
        arr.push(item)
    }

    return arr
}
